// import(/* webpackChunkName: "about" */ "./components/Landing.vue")

import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Login/Home";

import { TokenService } from "./services/storage.service";
import store from "./store/store";
import { ACTION_IS_LOGGED_IN } from "./store/constants/user";
Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        public: true, // Allow access to even if not logged in
        onlyWhenLoggedOut: true,
      },
    },

    {
      path: "/onboarding",
      name: "onboarding",
      component: () => import("./components/Onboarding/Onboarding.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some(
    (record) => record.meta.onlyWhenLoggedOut
  );
  const loggedIn = !!TokenService.getConfig("email");

  if (!isPublic && !loggedIn) {
    store.dispatch(ACTION_IS_LOGGED_IN, false);
    TokenService.removeCofnig();

    return next({
      path: "/",
    });
  }

  if (loggedIn && onlyWhenLoggedOut) {
    return next("/onboarding");
  }
  if (!to.matched.length) {
    next("/");
  }

  next();
});

export default router;
